<!-- Sidebar.vue -->
<template>
  <div>
    <div class="sidebar" :class="{ open: isOpen }">
      <div class="sidebar-container">
        <div class="sidebar-group">
          <div class="sidebar-header-container">
            <div class="sidebar-header">
              <div class="sidebar-logo-container">
                <img
                  class="sidebar-header-logo-icon"
                  alt=""
                  src="../../assets/sidebar-header-logo.svg"
                />
                <div class="text-display">
                  <div class="oto-ai">OTO AI</div>
                  <div class="dealership-name">Dick Poe Chrysler Jeep</div>
                </div>
              </div>
              <img
                class="x-icon"
                alt=""
                src="../../assets/x-icon.svg"
                @click="closeSidebar"
              />
            </div>
            <!-- <div class="separator-line"></div> -->
            <img
              class="separator-icon"
              loading="lazy"
              alt=""
              src="../../assets/separator.svg"
            />
          </div>
          <div class="sidebar-settings">
            <SideBarItem
              v-for="(item, index) in settingsItems"
              :key="index"
              :item="item"
              @clickedMenuItem="onShowDetails(item)"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      class="sidebar"
      :style="{
        width: showMyContactInfo ? '100%' : '85%',
      }"
      v-if="
        showPrivacyPolicy ||
        showDisclaimers ||
        showAboutOTO ||
        showMyContactInfo
      "
      :class="{
        open:
          isOpen &&
          (showPrivacyPolicy ||
            showDisclaimers ||
            showAboutOTO ||
            showMyContactInfo),
      }"
    >
      <div class="sidebar-container">
        <div class="sidebar-group">
          <PrivacyDisclaimerAbout
            v-if="!showMyContactInfo"
            :menuInfo="
              settingsItems[showPrivacyPolicy ? 2 : showDisclaimers ? 3 : 4]
            "
            @hide-details="closeDetails"
          />
          <MyContactInfo v-if="showMyContactInfo"   @hide-details="closeDetails"/>
        </div>
      </div>
    </div>
    <div
      class="overlay"
      v-if="isOpen && !showMyContactInfo"
      @click="closeSidebar"
    ></div>
  </div>
</template>

<script setup>
import { ref } from "vue";

import SideBarItem from "./SideBarItem.vue";
import PrivacyDisclaimerAbout from "./PrivacyDisclaimerAbout.vue";
import MyContactInfo from "./MyContactInfo.vue";

const settingsItems = [
  {
    label: "Units I like",
    info: "Only view units you are interested in",
    icon: require("../../assets/car.svg"),
  },
  {
    label: "My contact info",
    info: "Phone number and email",
    icon: require("../../assets/info.svg"),
  },
  {
    label: "Privacy Policy",
    info: "How we protect your data",
    icon: require("../../assets/privacypolicy.svg"),
  },
  {
    label: "Disclaimers",
    info: "OTO Usage and limitations",
    icon: require("../../assets/alerttriangle.svg"),
  },
  {
    label: "About OTO",
    info: "More information",
    icon: require("../../assets/about.svg"),
  },
];

const showMyContactInfo = ref(false);
const showPrivacyPolicy = ref(false);
const showDisclaimers = ref(false);
const showAboutOTO = ref(false);

defineProps({
  isOpen: { type: Boolean, required: true, default: false },
});

const sidebarCloseEmit = defineEmits(["close"]);

function closeSidebar() {
  sidebarCloseEmit("close");
  closeDetails();
}

function onShowDetails(menuInfo) {
  if (menuInfo.label === "Privacy Policy") {
    showPrivacyPolicy.value = true;
  } else if (menuInfo.label === "Disclaimers") {
    showDisclaimers.value = true;
  } else if (menuInfo.label === "About OTO") {
    showAboutOTO.value = true;
  } else if (menuInfo.label === "My contact info") {
    showMyContactInfo.value = true;
  } else {
    console.log(menuInfo);
  }
}

function closeDetails() {
  // Hide the Privacy Policy page
  showPrivacyPolicy.value = false;
  showDisclaimers.value = false;
  showAboutOTO.value = false;
  showMyContactInfo.value = false;
}
</script>

<style scoped>
.overlay {
  position: absolute;
  top: 0;
  right: 0;
  width: 13.46%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 3; /* Ensure the overlay is above the sidebar */
  transition: right 0.3s ease;
}

.sidebar {
  position: absolute;
  top: 0;
  left: -86.54%; /* Initially hidden */
  width: 86.54%;
  height: 100%;
  background-color: white;
  transition: left 0.01s ease;
}

.sidebar.open {
  left: 0; /* Slide in when open */
}

.sidebar-container {
  width: 100%;
  height: 100%;
  margin: 0 !important;
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  background-color: var(--white-default);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  /* gap: 311px 0px; */
  z-index: 4;
}

.sidebar-group {
  height: 100%;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px var(--padding-5xl);
  /* gap: var(--gap-xl); */
}

.sidebar-header-container {
  align-self: stretch;
  background-color: var(--white-default);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--padding-11xl) 0px var(--padding-xl) 0px;
  gap: var(--gap-xl);
}

.sidebar-header {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  gap: var(--gap-xl);
  max-width: 112%;
  flex-shrink: 0;
}

.sidebar-logo-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
}

.sidebar-header-logo-icon {
  height: 40px;
  width: 40px;
  position: relative;
  border-radius: 3.81px;
  overflow: hidden;
  flex-shrink: 0;
}

.text-display {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  font-size: 16px;
  text-align: left;
  color: var(--black-default);
  position: relative;
  letter-spacing: 0.01em;
  line-height: 24px;

  .oto-ai {
    width: 52px;
    font-weight: 600;
    display: inline-block;
  }
  .dealership-name {
    white-space: nowrap;
    margin-top: -4px;
    font-weight: 400;
  }
}

.x-icon {
  height: 48px;
  width: 48px;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  cursor: pointer;
  margin: 0rem -1.1rem 0rem 0rem;
}
.separator-icon {
  /* align-self: stretch;
  width: 94%;
  border: 0.03rem solid var(--gray-dark); */
  /* border: 0.5px solid #B0B0B0 */
  align-self: stretch;
  /* height: 1px; */
  position: relative;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  flex-shrink: 0;
}

.sidebar-settings {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 40px;
}
</style>
